import styled from "styled-components";

export const Main = styled.div`
   padding: 30px !important;
   width: 500px;

   .content {
      .time {
         display: flex;
         justify-content: space-between;
         position: relative;
         margin-bottom: 15px;
         
         input {
            border: 1px solid rgba(226, 232, 240, 1);
            padding: 10px;
            height: 40px;
            border-radius: 5px;
            font-size: 15px;
            width: calc((100% / 3) - 7.5px);
            text-align: center;

            &::placeholder {
               color: #000;
               opacity: 0.5;
            }
         }
         > svg {
            position: absolute;
            top: calc(50% - (18px / 2));
            left: 10px;
            opacity: 0.3;
            color: #000;
         }
      }
      .or {
         font-size: 15px;
         margin-bottom: 15px;
         text-align: center;
         color: #E02424;
      }
      .tiemzone {
         input {
            width: calc(25% - 7.5px);
         }
         .select {
            width: calc(50% - 7.5px);

            > div {
               border: 1px solid rgba(226, 232, 240, 1);
            }
         }
      }
      .tip {
         font-size: 17px;
         margin-bottom: 5px;
         box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
         border-radius: 7.5px;
         padding: 15px;
         font-size: 15px;
         margin-bottom: 13px;
         line-height: 1.4;

         svg {
            margin-right: 7.5px;
         }
         &.first {
            background-color: rgba(239, 246, 255, 1);
            border: 1px solid rgba(191, 219, 254, 1);
            color: rgba(30, 64, 175, 1);
            svg {
               color: rgba(37, 99, 235, 1);
            }
         }
         &.last {
            background-color: rgba(255, 251, 235, 1);
            border: 1px solid rgba(253, 230, 138, 1);
            color: rgba(146, 64, 14, 1);
            svg {
               color: rgba(217, 119, 6, 1);
            }
         }
      }
      .background {
         display: flex;
         margin: 15px 0 30px;
         cursor: pointer;
         transition: all .2s ease-in-out;
         box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
         border: 1px solid rgba(226, 232, 240, 1);
         padding: 15px;
         border-radius: 7.5px;

         > div:first-of-type {
            display: flex;
            align-items: center;
            justify-content: center;
            border: 2px solid rgba(14, 116, 144, 1);
            min-width: 20px;
            height: 20px;
            color: #fff;
            border-radius: 5px;
            margin-right: 15px;
            font-size: 13px;
         }
         span {
            display: block;

            &:first-of-type {
               font-size: 16px;
               color: rgba(14, 116, 144, 1);
               margin-bottom: 5px;
            }
            &:last-of-type {
               font-size: 15px;
               opacity: 0.65;
            }
         }
         &:hover {
            opacity: 0.85;
         }
      }
      .action {
         display: flex;
         justify-content: space-between;
      }
      button {
         display: flex;
         align-items: center;
         justify-content: center;
         width: calc((100% / 2) - 7.5px);
         height: 40px;
         border: 1px solid transparent;
         border-radius: 5px;
         background-color: #3E82F8;
         color: #fff;
         transition: all .2s ease-in-out;
         cursor: pointer;
         font-size: 14px;

         svg {
            margin-right: 7.5px;
         }
         &.cancel {
            background-color: transparent;
            color: initial;
            border-color: rgba(226, 232, 240, 1);
            box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);

            &:hover {
               background-color: rgba(248, 250, 252, 1);
               opacity: 1;
            }
         }
         &.stop {
            background-color: #E02424;

            svg {
               margin-right: 7.5px;
            }
         }
         &:disabled {
            opacity: 0.65;
            cursor: default;
            &:hover { opacity: 0.65; }
         }
         &:hover {
            opacity: 0.9;
         }
      }
   }
`;